import { API_URLS } from "../../constants";
import axios from "axios";
import apiClient from "../../utils/interceptor";

export const getScanStageReportDetails = async (scanStageId) => {
  try {
    const response = await apiClient.get(
      `${API_URLS.SCAN.GET_SCAN_STAGE_REPORT}/${scanStageId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching scan stage report details:", error);
    throw error;
  }
};

export const updateDefectSignificance = async (defect) => {
  try {
    const response = await apiClient.patch(
      API_URLS.SCAN.UPDATE_DEFECT_SIGNIFICANCE,
      defect
    );

    return response.data;
  } catch (error) {
    console.error("Error updating defect significance:", error);
    throw error;
  }
};

export const updateReportedToManager = async (data) => {
  try {
    const response = await apiClient.patch(
      API_URLS.SCAN.UPDATE_REPORTED_TO_MANAGER,
      data
    );

    return response.data;
  } catch (error) {
    console.error("Error updating reported_to_manager:", error);
    throw error;
  }
};

export const updateReportPublished = async (data) => {
  try {
    const response = await apiClient.patch(
      API_URLS.SCAN.UPDATE_REPORT_PUBLISHED,
      data
    );

    return response.data;
  } catch (error) {
    console.error("Error updating report_published:", error);
    throw error;
  }
};

export const getScanPdf = async (scanId, stageName) => {
  try {
    const payload = {
      scan_id: scanId,
      stage_name: stageName,
    };

    const response = await apiClient.post(
      API_URLS.SCAN.GET_SCAN_PDF,
      payload,
      { responseType: "blob" }
    );

    const blob = new Blob([response.data], { type: "application/pdf" });
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `scan_${scanId}_${stageName}.pdf`;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);

    return response;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getScanImagesZip = async (scanStageId) => {
  try {
    const response = await apiClient.get(
      `${API_URLS.SCAN.GET_SCAN_IMAGES_ZIP}/${scanStageId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching scan images ZIP:", error);
    throw error;
  }
};

export const updateScanInfo = async (data) => {
  try {
    const response = await apiClient.patch(
      API_URLS.SCAN.UPDATE_SCAN_INFO,
      data
    );

    return response.data;
  } catch (error) {
    console.error("Error updating container number:", error);
    throw error;
  }
};

export const updateScanStageInfo = async (data) => {
  try {
    const response = await apiClient.patch(
      API_URLS.SCAN.UPDATE_SCAN_STAGE_INFO,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error updating scan stage info:", error);
    throw error;
  }
};

export const updateScanStageDefect = async (data) => {
  try {
    const response = await apiClient.post(
      API_URLS.SCAN.UPDATE_SCAN_STAGE_DEFECT,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error updating scan stage defects:", error);
    throw error;
  }
};
 
export const updateScanStageImages = async (formData) => {
  try {
    const response = await apiClient.post(
      API_URLS.SCAN.UPDATE_SCAN_STAGE_IMAGES,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", 
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating scan stage images:", error);
    throw error;
  }
};

export const getDefectClasses = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_CV_API_URL}/defect_classes`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching defect classes:", error);
    throw error;
  }
};